import NextRecommendation from './NextRecommendation';

export default NextRecommendation;
